// Only matches whole param names inside the query string, not the path.
export const redactUrlQueryParams = (url: string): string =>
  url.replace(/([?&]invitation_token=)[^&#]+/g, "$1[REDACTED]");
